import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=fe0d2d84&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=fe0d2d84&prod&lang=scss&scoped=true"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=fe0d2d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0d2d84",
  null
  
)

export default component.exports